import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "./ui/accordion";
import { useI18n } from "../i18n/I18nContext";

export default function Faq() {
    const { tRaw, t } = useI18n();
    const items = tRaw("faq.items") || [];

    return (
        <section id="faq" data-testid="faq-section" className="max-w-3xl mx-auto px-4 sm:px-6 py-16 scroll-mt-20">
            <div className="text-xs font-semibold tracking-[0.2em] uppercase text-slate-500">
                {t("faq.eyebrow")}
            </div>
            <h2 className="font-display mt-3 text-2xl sm:text-3xl lg:text-4xl tracking-tight font-bold text-slate-900">
                {t("faq.title")}
            </h2>
            <p className="mt-3 text-slate-600">{t("faq.intro")}</p>

            <Accordion
                type="single"
                collapsible
                className="mt-8 divide-y divide-slate-200 border-y border-slate-200"
                data-testid="faq-accordion"
            >
                {items.map((item, i) => (
                    <AccordionItem key={i} value={`q${i}`} data-testid={`faq-item-${i}`} className="border-0">
                        <AccordionTrigger className="text-left text-base font-semibold text-slate-900 hover:no-underline py-5">
                            {item.q}
                        </AccordionTrigger>
                        <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                            {item.a}
                        </AccordionContent>
                    </AccordionItem>
                ))}
            </Accordion>
        </section>
    );
}
